export const contentIds = {
  heading: "cid$#4395745#",
  ticketsSold: "cid$#4395746#",
  validAndOnTime: "cid$#4395747#",
  protection: "cid$#4395748#",
} as const;
